
<div  [ngClass]="showlogo ? '':'tc-article-container'"*ngIf="outcome">
  <div *ngIf="showlogo" class="bgc-fasb-blue font-white pb-4rem">
    <div class="height-4rem">
      <img alt="logo" [src]="logo" class="icon-fasb-logo pt-1">
    </div>
  </div>
  <p *ngIf="showActionBtns" class="tc-article font-size-10pt">
    In order to access the Governmental Accounting Research System (GARS) website, you need to agree to the latest terms and conditions.
  </p>
  <p *ngIf="showActionBtns" class="tc-article font-size-10pt">
    Please <strong>read these terms and conditions carefully</strong> and then accept the agreement.
  </p>
  <article id="printArticle" class="tc-article article-font print-content print-all-content" [innerHTML]="body"></article>
  <div *ngIf="showActionBtns || showPrint">
    <p *ngIf="showActionBtns" class="tc-article"><span class="prostat"><strong><span style="font-size:10.0pt">TO ACCEPT THESE TERMS AND CONDITIONS AND ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THE SAME, PLEASE CLICK THE ”I ACCEPT” BUTTON.</span></strong></span></p>
    <div *ngIf="showActionBtns || showPrint"class="flex-display justify-content-center mb-1">
      <button mat-button class="print-button flex-display align-items-center" *ngIf="showActionBtns" (click)="printPage()">
        <img src="../../../../assets/icons/Print.svg" alt=""> &nbsp;
        <span class="print-button-text">
          Print this page
        </span>
      </button>
    </div>
    <div *ngIf="showActionBtns" class="flex-display justify-content-center mb-1">
      <p>
        Do you accept these terms and conditions?
      </p>
    </div>
    <div *ngIf="showActionBtns" class="tc-acction-btns">
      <button style="margin:10px;" mat-button class="btn-secondary " (click)="doNotAccept()">I DO NOT ACCEPT</button> &nbsp;
      <button style="margin:10px;" mat-button class="btn-primary " (click)="accept()">I ACCEPT</button>
    </div>
  </div>

</div>
